import { render } from "./Home.vue?vue&type=template&id=ebd9a75e"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=ebd9a75e&lang=css"
script.render = render

export default script